module.exports = __webpack_public_path__ + "0e07900d29cd01ea6403f184bc73eff4.svg";